module.exports = __webpack_public_path__ + "c0fafa8397437c95848724aed686d63b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/Poppins/Poppins-Thin.ttf
// module id = 1264
// module chunks = 0